<template>
  <b-modal :id="id" v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
    :title="prefix + title">
    <UnidadeAdministrativa @onDblClickUnidadeAdministrativa="onDblClickUnidadeAdministrativa" :id="id + '-list'" :prefix="prefix + title" >
    </UnidadeAdministrativa>
  </b-modal>
</template>
<script>
export default {
  components: {
    UnidadeAdministrativa: ()=>import("@/modules/cadastros/unid-administrativa/UnidadeAdministrativaList.vue")
    ,
  },
  name: "ModalPageUnidadeAdministrativa",
  props: {
    id: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Unidade Administrativa",
    },
    idPai:
      { type: Number, default: null },
  },

  data() {
    return {
      showModal: true,
    }
  },

  beforeMount() {
  },

  methods: {
    onDblClickUnidadeAdministrativa(item){
      this.$emit("onselect", item);

    },
    cancelar() {
      this.$emit("onselect");
    },
  },
}
</script>
